/**
 * Collection of different urls used within the module.
 */
let urls: {
  htmlComponentAssets: string;

  /**
   * Contains the base uurl of the Component Framework API.
   */
  componentFramework: string;

  /**
   * Contains the base url of the i-book v3 application.
   */
  ibook3: string;

  /**
   * Contains the base url of the i-book v4 application.
   */
  ibook4: string;

  /**
   * Contains an absolute url to the gExport script, which is used to
   * generate screenshots of some pages.
   */
  gExport: string;

  /**
   * Contains the base url of the media library.
   */
  mediaLibrary: string;

  /**
   * Contains theh base url for all PM2 endpoints.
   */
  pm2: string;

  /**
   * Contains the base url for media files hosted on the PM2 servers.
   */
  pm2Media: string;

  /**
   * base url for the 23Video integration
   */
  video23: string;
  video23Audio: string;
};

switch (process.env.APP_ENV ?? process.env.NODE_ENV) {
  case "production":
    urls = {
      htmlComponentAssets: "https://komponenter.gyldendal.dk/html/assets",
      componentFramework: "https://componentframework.gyldendal.dk",
      ibook3: "https://ibog3.gyldendal.dk",
      ibook4: "https://i-bog.gyldendal.dk",
      gExport: "https://exportservice.gyldendal.dk/gExport.js",
      mediaLibrary: "https://medialibrary.gyldendal.dk",
      pm2: "https://api-portalmotor.gyldendal.dk/api",
      pm2Media: "https://portalmotor.gyldendal.dk",
      video23: "https://gyldendalprodukter.videomarketingplatform.co",
      video23Audio: "https://gu-grundskole-lyd.twentythree.com",
    };
    break;

  case "staging":
    urls = {
      htmlComponentAssets: "https://qa-komponenter.gyldendal.dk/html/assets",
      componentFramework: "https://qa-componentframework.gyldendal.dk",
      ibook3: "https://ibog3.gyldendal.dk",
      ibook4: "https://qa-ibog4.gyldendal.dk",
      gExport: "https://qa-exportservice.gyldendal.dk/gExport.js",
      mediaLibrary: "https://medialibrary.gyldendal.dk",
      pm2: "https://qa-api-portalmotor.gyldendal.dk/api",
      pm2Media: "https://qa-portalmotor.gyldendal.dk",
      video23: "https://gyldendalprodukter.videomarketingplatform.co",
      video23Audio: "https://gu-grundskole-lyd.twentythree.com",
    };
    break;

  default:
    urls = {
      htmlComponentAssets: "https://test-komponenter.gyldendal.dk/html/assets",
      componentFramework: "https://test-componentframework.gyldendal.dk",
      ibook3: "https://test-ibog3.gyldendal.dk",
      ibook4: "https://test-ibog4.gyldendal.dk",
      gExport: "https://test-exportservice.gyldendal.dk/gExport.js",
      mediaLibrary: "https://test-medialibrary.gyldendal.dk",
      pm2: "https://test-api-portalmotor.gyldendal.dk/api",
      pm2Media: "https://test-portalmotor.gyldendal.dk",
      video23: "https://test-player-mediaprovider.gyldendal.dk",
      video23Audio: "https://gu-grundskole-lyd-test.twentythree.com",
    };
}

export { urls };
